// extracted by mini-css-extract-plugin
export var actionIcon = "_pa-0";